<template>
  <div class="recommended-progress">
    Recommended job {{ current_index }} of {{ count }}
  </div>
</template>

<script>
  import RecommendedJobs from '@/mixins/RecommendedJobs';

	export default {
		name: 'JobsRecommendedNext',

    mixins: [RecommendedJobs],

		props: {
      jobid: {
        type: String
      }
		},

		data() {
			return {
        recommended_jobs: false,
				manager: true
			}
		},

    mounted() {
			this.emitter.on('refresh:recommended:jobs', this.refreshState);
      this.refreshState();
    },

    methods: {
			refreshState() {
				this.recommended_jobs = this.getRecommended();
				this.recommended_jobs.index = this.recommended_jobs.jobs.findIndex((job) => {return job.objectID == this.jobid});
				this.recommended_jobs.jobs[this.recommended_jobs.index].seen = true;
				this.setRecommended(this.recommended_jobs);
			},
    }
	}
</script>
